/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function isSelected(pathname: string, path: string) {
  return pathname.includes(path);
}
